import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import LandingPage from "./components/LandingPage";
import DiagnosticPage from "./components/DiagnosticPage";
import ChatPage from "./components/ChatPage";
import ShopPage from "./components/ShopPage";
import ReviewsPage from "./components/ReviewsPage";
import ServicesHubPage from "./components/ServicesHubPage";
import WorkPage from "./components/WorkPage";
import NosotrosPage from "./components/NosotrosPage";
import CartPage from "./components/CartPage";
import CheckoutTransferPage from "./components/CheckoutTransferPage";
import CheckoutTransferSuccessPage from "./components/CheckoutTransferSuccessPage";
import SpeedTestPage from "./components/SpeedTestPage";
import ScrollToTop from "./components/ScrollToTop";

const ROUTES = [
  { path: "/", element: <LandingPage /> },
  { path: "/diagnostico", element: <DiagnosticPage /> },
  { path: "/ayuda", element: <ChatPage /> },
  { path: "/tienda", element: <ShopPage /> },
  { path: "/packs", element: <ServicesHubPage /> },
  { path: "/trabajos", element: <WorkPage /> },
  { path: "/resenas", element: <ReviewsPage /> },
  { path: "/nosotros", element: <NosotrosPage /> },
  { path: "/servicios", element: <ServicesHubPage /> },
  { path: "/planes", element: <ServicesHubPage /> },
  { path: "/checkout", element: <CartPage /> },
  { path: "/checkout/transferencia", element: <CheckoutTransferPage /> },
  { path: "/checkout/transferencia/orden/:orderNumber", element: <CheckoutTransferSuccessPage /> },
  { path: "/velocidad", element: <SpeedTestPage /> },
];

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToTop />
        <Routes>
          {ROUTES.map((route) => (
            <Route key={route.path} path={route.path} element={route.element} />
          ))}
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
